export const UMB_ROLLBACK_REPOSITORY_ALIAS = 'Umb.Repository.Rollback';
